import PropTypes from 'prop-types';

var Variants;
(function (Variants) {
    Variants["INFORMATIVE"] = "informative";
    Variants["SUCCESS"] = "success";
    Variants["DANGER"] = "danger";
    Variants["WARNING"] = "warning";
    Variants["BASE"] = "base";
})(Variants || (Variants = {}));
var propTypes = {
    small: PropTypes.bool,
    large: PropTypes.bool,
    text: PropTypes.string.isRequired,
    variant: PropTypes.oneOf([
        Variants.INFORMATIVE,
        Variants.SUCCESS,
        Variants.DANGER,
        Variants.WARNING,
        Variants.BASE,
    ]),
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.node,
    suffixIcon: PropTypes.node,
    testId: PropTypes.string,
    'data-testid': PropTypes.string,
    altText: PropTypes.string,
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltipProps: PropTypes.object,
};
var defaultProps = {
    small: false,
    large: false,
    backgroundColor: '',
    textColor: '',
    variant: Variants.INFORMATIVE,
    icon: '',
    suffixIcon: '',
    maxWidth: 280,
};

export { Variants, defaultProps, propTypes };
